import * as React from 'react'
import clx from 'classnames'
import styles from './styles.module.scss'
import { CSSProperties, ReactNode } from 'react'

interface TableListCellProps {
  align?: 'left' | 'center' | 'right'
  children?: ReactNode
  className?: string
  flex?: boolean | 'none' | number
  index?: number
  testId?: string
  displayOverflow?: boolean
  minWidth?: CSSProperties['minWidth']
  variant?: 'primary'
  width?: CSSProperties['width']
  style?: CSSProperties
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
}

export const TableCell = ({
  align = 'left',
  children,
  className,
  flex = false,
  index,
  testId,
  displayOverflow = false,
  minWidth,
  variant,
  width,
  style = {},
  onClick,
}: TableListCellProps) => {
  const _style: CSSProperties = {}

  if (typeof flex === 'number') {
    _style.flex = flex
  }

  if (width) {
    _style.width = width
  }

  if (minWidth) {
    _style.minWidth = minWidth
  }

  return (
    <div
      data-test-id={testId}
      data-index={index}
      onClick={onClick}
      style={{
        ...(typeof style === 'object' ? style : {}),
        ...(typeof _style === 'object' ? _style : {}),
      }}
      className={clx(
        styles.Cell,
        {
          [styles.Cell_AlignLeft]: align === 'left',
          [styles.Cell_AlignCenter]: align === 'center',
          [styles.Cell_AlignRight]: align === 'right',
          [styles.Cell_Flex]: flex === true || flex === 1,
          [styles.Cell_NoFlex]: flex === false || flex === 'none',
          [styles.Cell_Primary]: variant === 'primary',
          [styles.Clickable]: !!onClick,
          [styles.DisplayOverflow]: displayOverflow,
        },
        className,
      )}
    >
      {children}
    </div>
  )
}
